import ArrowWideLeft from "@/assets/icons/arrowWide/left/medium.svg?react"
import { cn } from "@/lib/utils"

import { Typography } from "../Typography"

// Main Header container
interface HeaderProps {
  children: React.ReactNode
  className?: string
}

export const Header = ({ children, className = "" }: HeaderProps) => {
  return <header className={cn("space-y-1", className)}>{children}</header>
}

// Header sub-components
interface HeaderBackButtonProps {
  href?: string
  className?: string
  "aria-label"?: string
}

export const HeaderBackButton = ({
  href,
  className = "",
  "aria-label": ariaLabel = "Go back",
}: HeaderBackButtonProps) => {
  return (
    <a className={cn("flex items-center justify-center", className)} aria-label={ariaLabel} href={href}>
      <ArrowWideLeft className="h-6 w-6" />
    </a>
  )
}

interface HeaderContentProps {
  children: React.ReactNode
  className?: string
}

export const HeaderContent = ({ children, className = "" }: HeaderContentProps) => {
  return <div className={cn("flex flex-col space-y-1", className)}>{children}</div>
}

interface HeaderDescriptionProps {
  children: React.ReactNode
  className?: string
}

export const HeaderDescription = ({ children, className = "" }: HeaderDescriptionProps) => {
  return (
    <Typography as="div" variant="body1" className={cn("text-neutral-text", className)}>
      {children}
    </Typography>
  )
}

interface HeaderRightContentProps {
  children: React.ReactNode
  className?: string
}

export const HeaderRightContent = ({ children, className = "" }: HeaderRightContentProps) => {
  return <div className={cn("flex items-center gap-2", className)}>{children}</div>
}

interface HeaderRowProps {
  children: React.ReactNode
  className?: string
}

export const HeaderRow = ({ children, className = "" }: HeaderRowProps) => {
  return <div className={cn("flex w-full items-center justify-between gap-2", className)}>{children}</div>
}

interface HeaderTitleProps {
  children: React.ReactNode
  className?: string
}

export const HeaderTitle = ({ children, className = "" }: HeaderTitleProps) => {
  return (
    <Typography as="h1" variant="subtitle" weight="medium" className={cn("flex items-center gap-1", className)}>
      {children}
    </Typography>
  )
}
